import type { Theme } from '@/types/theme';

/**
 * Collapse a `Theme` (which may be `'system'` or `undefined`) to the concrete
 * light/dark the page is actually painted in.
 *
 * Consumers that style via CSS get this for free from the `theme-light` /
 * `theme-dark` class on `<html>`. Consumers *outside* the cascade — Stripe
 * Elements' Appearance API, canvas, anything handed literal hex values — have
 * to resolve it themselves, and `theme === 'light'` is the wrong test: it
 * treats the default `'system'` as dark and paints white text onto a white
 * page (DEV-6565: invisible card number for system-light users).
 */
export const resolveTheme = (
  theme: Theme,
  systemPrefersDark: boolean
): 'light' | 'dark' => {
  if (theme === 'light' || theme === 'dark') {
    return theme;
  }

  return systemPrefersDark ? 'dark' : 'light';
};
